import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { SpinnerService } from '../services/util/spinner.service';
import { Constants } from '../constants/constants';
import { environment } from '../../environments/environment';

export const httpInterceptor: HttpInterceptorFn = (req, next) => {
  const isSecure = environment.esHttps;
  let authReq;
  const spinnerService = inject(SpinnerService);
  if (!req.url.includes('/renovarToken') && !req.headers.get('skip')) {
    spinnerService.showSpinner();
  }
  if(!isSecure){
    const authToken = sessionStorage.getItem(Constants.ACCESS_TOKEN);
    authReq = authToken
      ? req.clone({ setHeaders: { Authorization: `Bearer ${authToken}` } })
      : req;
  }else{
    if (!req.url.includes('recaptcha')) {
      authReq = req.clone({
        withCredentials: true,
      });
    } else {
      authReq = req;
    }
  }

  return next(authReq).pipe(finalize(() => spinnerService.hideSpinner()));
};
